/*@flow*/
import gql from "graphql-tag";
import type { DocumentNode } from "graphql";

export default (gql(`
  query GetAssociatedResources(
    $id: ID!,
    $resourceName: String!,
    $companyId: ID!,
    $first: Int
    $last: Int
    $before: String
    $after: String
    $order: String
    $orderDir: String
  ) {
    company(id: $companyId) {
      id
      resource(id: $id, resourceName: $resourceName) {
        ... on Property {
          id
          events(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              status
              resourceType
              hashid
              recurrences
              category
            }
          }
          tenants(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              hashid
              status
              category
              resourceType
            }
          }
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Building {
          id
          tenants(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              hashid
              status
              category
              resourceType
            }
          }
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Development {
          id
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Event {
          id
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Listing {
          id
          events(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              hashid
              recurrences
              category
              resourceType
            }
          }
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Organization {
          id
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Tenant {
          id
          events(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              hashid
              recurrences
              category
              resourceType
            }
          }
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
        ... on Unit {
          id
          contacts(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              email
              hashid
              phone
              contactType
              status
              resourceType
            }
          }
        }
      ... on Contact {
          id
          events(
            first: $first
            last: $last
            before: $before
            after: $after
            order: $order
            orderDir: $orderDir
          ) {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            nodes {
              id
              name
              status
              resourceType
              hashid
              recurrences
              category
            }
          }
        }
      }
    }
  }
`): DocumentNode);
